(function($){
	
	/**
	 * Los elementos del menú con "hijos" (submenu) abren el submenú
	 * al ser clicados
	 */

	let links = $('.menu-item-has-children > a');
	let submenus = $('.sub-menu');

	links.on('click',function(e){
		e.preventDefault();
		openSubmenu($(this));
	});

	function openSubmenu(link){

		if( link.hasClass('js-dropdown-is-open') ){
			link.toggleClass('js-dropdown-is-open');
			link.next('.sub-menu').slideToggle();
		}else{
			links.removeClass('js-dropdown-is-open');
			submenus.slideUp();

			link.addClass('js-dropdown-is-open');
			link.next('.sub-menu').slideToggle();
		}
	}


	/**
	 * Muestra u oculta el menú mobile
	 */

	let mobileMenu = $('#bar-menu-mobile');

	$('.bar-masthead__toggle-menu').on('click',function(e){
		mobileMenu.toggleClass('js-bar-menu-mobile--is-visible');
	});


	/**
	 * Almacena en la sesión el valor de la barra superior de destacados para ocultarla
	 */

	let featuredTopBar = $('#bar-featured-topbar');

	$('#bar-featured-topbar__toggle').on('click',function(e){
		featuredTopBar.slideUp();
		sessionStorage.setItem('bar-featured-topbar-status','hidden');
	});

})(jQuery)